<i18n>
{
    "et": {
        "Country": "Riik",
        "Load more countries": "Lae rohkem riike"
    }
}
</i18n>
<template>
  <div>
    <v-autocomplete
      v-model="selected"
      :filter="filter"
      @change="$emit('change', selectedCountry)"
      @input="$emit('input', $event)"
      :items="countries"
      v-bind="$attrs"
      item-value="code"
      @click="autoFetch ? (search = true) : null"
    >
      <template #label v-if="label">
        <span v-t="label" />
      </template>
      <template #item="slotProps">
        <country-flag :flag="slotProps.item.flag" left />
        {{ slotProps.item.name }} ({{ slotProps.item.native_name }})
      </template>
      <template #append-item>
        <v-list-item v-if="loading">
          <v-list-item-content class="d-flex">
            <v-progress-circular indeterminate color="info"></v-progress-circular>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else-if="!fetched" @click="search = true">
          <v-list-item-content>
            <v-list-item-title>
              <em>
                {{ "Load more countries" }}
              </em>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template #selection="slotProps">
        <country-flag :flag="slotProps.item.flag" left />
        {{ slotProps.item.name }} ({{ slotProps.item.native_name }})
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import CountryFlag from "./CountryFlag";
const defaultCountries = [
  {
    name: "Estonia",
    native_name: "Eesti",
    code: "EE",
    flag: "ee.svg",
  },
  {
    name: "Finland",
    native_name: "Suomi",
    code: "FI",
    flag: "fi.svg",
  },
  {
    name: "Latvia",
    native_name: "Latvija",
    code: "LV",
    flag: "lv.svg",
  },
];
export default {
  components: {
    CountryFlag,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    defaultCountries: {
      type: Array,
      default: () => defaultCountries,
    },
    label: {
      type: String,
      default: "Country",
    },
    autoFetch: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selected: this.value
        ? this.value
        : this.defaultCountries && this.defaultCountries[0] && this.defaultCountries[0].code
        ? this.defaultCountries[0].code
        : null,
      countries: this.defaultCountries,
      loading: false,
      search: null,
      fetched: null,
    };
  },

  created() {
    if (!this.selectedCountry) {
      this.search = true;
    }
  },

  watch: {
    search(value) {
      if (this.fetched || this.loading) return;
      this.loading = true;
      this.fetchCountries();
    },
  },

  computed: {
    selectedCountry() {
      return this.countries.find((item) => item.code === this.selected);
    },
  },

  methods: {
    filter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.native_name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    },
    async fetchCountries() {
      this.loading = true;
      try {
        const response = await this.axios({
          method: "get",
          url: "api/countries",
          baseURL: "/",
        });

        this.countries = response.data;
        this.fetched = true;
        this.$emit("input", this.selected);
      } catch (error) {
        // console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss"></style>
